<template>
  <div class="container">
    <div class="banner">
      <div class="content">
        <div class="caption">课程学习</div>
        <p>Course learning</p>
      </div>
    </div>
    <div class="news-caption">二级注册建造师继续教育学习</div>
    <div class="content">
      <Course
        @getCourseData="getCourseData"
        :courseTypeList="courseTypeList"
        :courseList="courseList"
        :courseTotal="courseTotal"
        :catalogueList="catalogueList"
        :styleObject="styleObject"
      />
    </div>
  </div>
</template>

<script>
import Course from "@/components/Course.vue";
import { getType, getCourseList } from "@/api";
export default {
  name: "CourseLearning",
  components: { Course },
  data() {
    return {
      courseTypeList: [], //课程类型
      catalogueList: [], //专业目录
      courseList: [],
      courseTotal: 0,
      styleObject: {
        "margin-top": "120px",
        "margin-bottom": "38px",
      },
    };
  },

  mounted() {
    this.getDataType();
    this.getCourseData();
  },
  methods: {
    getDataType() {
      getType("ej_course_type").then((res) => {
        this.courseTypeList = res.data;
        localStorage.setItem('courseTypeList',JSON.stringify(res.data))
       // this.$store.commit("COURSE_TYPE", res.data);
      });
      getType("ej_course_major").then((res) => {
        this.catalogueList = res.data;
      });
    },
    getCourseData(CourseObj) {
      getCourseList(CourseObj).then((res) => {
        this.courseList = res.rows;
        this.courseTotal = res.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f4f8;

  .banner {
    min-width: 1600px;
    color: #fff;
    height: 510px;
    background: url("../assets/image/kec.png");
    background-size: 100% 100%;
    padding-top: 170px;
    .content {
      padding-left: 150px;
    }
    .caption {
      font-size: 46px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      padding-top: 5px;
    }
  }

  .news-caption {
    color: #000;
    text-align: center;
    font-weight: bold;
    font-size: 36px;
    padding-top: 120px;
    margin-bottom: 75px;
  }
  .pages {
    padding-top: 120px;
  }
}
</style>
